/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_DigitsInputs */

const en_reference_field_digits = /** @type {(inputs: Reference_Field_DigitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digits`)
};

/**
* | output |
* | --- |
* | "Digits" |
*
* @param {Reference_Field_DigitsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_digits = /** @type {((inputs?: Reference_Field_DigitsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_DigitsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_digits(inputs)
});